// extracted by mini-css-extract-plugin
module.exports = {"image":"section-end-module--image--1v2NL","retour":"section-end-module--retour--us578"};